import React from 'react'

import useGame from 'utils/hooks/queries/games/useGame'

import { GameDialog } from './GameDialog'
import useGameDialog from './hooks/useGameDialog'
import { Box, Glass } from './styles'

export function MobileDialog() {
  const { slug, close } = useGameDialog()
  const { data: game, isPending } = useGame({ slug })

  if (!game || isPending) {
    return null
  }

  return (
    <Box>
      <GameDialog game={game} />
      <Glass onClick={close} />
    </Box>
  )
}
